import React from 'react';
import { Toaster } from 'sonner';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Packages from '../components/Packages';
import Upgrades from '../components/Upgrades';
import Gallery from '../components/Gallery';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import '../styles/photobooth.css';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black font-body">
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151'
          }
        }}
      />
      <Header />
      <main>
        <Hero />
        <Packages />
        <Upgrades />
        <Gallery />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
